<template>
  <d-modal
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('service.searchServices') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-col cols="12">
        <d-row>
          <d-col
            v-for="(service, index) of foundedServices"
            :key="'search-result-services-' + index"
            cols="4">
            <d-card class="w-100 p-3 mb-4">
              <img
                v-if="service.image_url"
                :src="service.image_url"
                alt=""
                class="service-image" />
              <span
                v-else
                class="service-empty-image">
                <i class="material-icons">camera_alt</i>
              </span>
              <div class="text-center">
                {{ service.code }}<br>
                <small
                  v-if="getServicePrice(service.id)"
                  class="text-primary">
                  {{ $t('price.priceFrom') }}: {{ getServicePrice(service.id) }} / {{ $t('ui.piecesAbbr') }}
                </small>
              </div>

              <d-button
                class="w-100 mt-2"
                @click.prevent="addService(service.id)">
                {{ $t('ui.addToOffer') }}
              </d-button>
            </d-card>
          </d-col>
        </d-row>

        <pagination
          :meta-data="paginationMetaData"
          :initial-page="currentPage" />
      </d-col>
    </d-modal-body>
  </d-modal>
</template>

<script>
import HasPagination from './../../mixins/HasPagination.vue';
import ListUtils from './../../utils/ListUtils.js';
import Pagination from './../../components/common/Pagination.vue';

export default {
  name: 'request-creator-services-search-popup',
  props: {
    currencyId: {
      default: 0,
      type: Number
    },
    selectedCurrencySymbol: {
      default: '',
      type: String
    },
    services: {
      default: () => ([]),
      type: Array
    }
  },
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data () {
    return {
      foundedServices: [],
      searchInProgress: false
    };
  },
  mounted () {
    this.searchInProgress = false;
    this.loadFilteredData();
  },
  methods: {
    addService (serviceID) {
      this.$bus.$emit('request-creator-add-services-group', serviceID);
      this.handleClose();
    },
    handleClose () {
      this.$bus.$emit('request-creator-services-search-popup-close');
    },
    cancel () {
      this.handleClose();
    },
    getServicePrice (serviceGroupID) {
      let servicesInGroup = this.services.filter(service => service.group_id === serviceGroupID);
      let lowestPrice = false;

      if (!servicesInGroup.length) {
        return false;
      }

      for (let i = 0; i < servicesInGroup.length; i++) {
        let prices = servicesInGroup[i].prices.filter(price => price.currency_id === this.currencyId);

        if (prices.length) {
          for (let j = 0; j < prices.length; j++) {
            if (lowestPrice === false) {
              lowestPrice = prices[j].price;
            } else if (prices[j].price < lowestPrice) {
              lowestPrice = prices[j].price;
            }
          }
        }
      }

      if (lowestPrice !== false) {
        return Number(lowestPrice).toFixed(2) + ' ' + this.selectedCurrencySymbol;
      }

      return false;
    },
    loadFilteredData () {
      ListUtils.loadPaginatedItemsData(this, {
        method: 'get',
        endpoint: '/customer-panel/services/groups/items?page=' + this.currentPage,
        listField: 'foundedServices'
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.modal /deep/ .modal-dialog {
  max-width: 1000px;
  width: 100%;

  .modal-body {
    max-height: 80vh;
    overflow: auto;
  }
}

.search-result-service-image {
  width: 100%;
}

.service {
  &-image {
    height: auto;
    margin: 0 auto 10px auto;
    max-height: 120px;
    max-width: 120px;
    width: auto;
  }

  &-empty-image {
    align-items: center;
    background: #e5e5e5;
    color: #fff;
    display: flex;
    font-size: 48px;
    height: 120px;
    justify-content: center;
    margin: 0 auto 10px auto;
    width: 120px;
  }
}
</style>
